export default __webpack_public_path__ + "ce51727ebf244f1766b46b762d8b2b21.svg";